import { Apis } from "../../lib/Apis";

export const useQuotation = () => {
    const getProducts = async (setProductList) => {
        try {
            const response = await Apis.getAllProducts();
            setProductList(response.data.products);
        } catch (error) {
            console.error(error);
        }
    }
    const generatePdf = async (data, setPdfFileLink) => {
        const response = await Apis.generatePdf(data);
        const fileUrl = response?.data?.fileUrl;
        if (setPdfFileLink && fileUrl) setPdfFileLink(fileUrl);
        return fileUrl;
    }
    const getVarinatByProductId = async (productId) => {
        try {
            const response = await Apis.getVarinatByProductId(productId);
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }
    const getColorsByVariantId = async (variantId) => {
        try {
            const response = await Apis.getColorsByVariantId(variantId);
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }
    return {
        getProducts,
        generatePdf,
        getVarinatByProductId,
        getColorsByVariantId,
    }
}